import { Box } from "@mui/material";
import * as React from "react";
import { useEffect, useState } from "react";
import { ConfirmationButton } from "source/components/framework/Button/ConfirmationButton";
import { ITreeListItem, TreeList } from "source/components/framework/List/TreeList";
import { PageChartFilterDrawer } from "source/components/framework/Page/PageChartFilterDrawer";
import { AppButton } from "ui/Scripts/source/components/framework/Button/AppButton";
import { ITaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { Translations } from "ui/Scripts/source/models/translations";

interface ITaskPageSelectChartDrawerProps {
    taskTypes: ITaskEditTypeItem[];
    onCancel: () => void;
    onSelect: (taskTypeId: string, chartName: string) => void;
}

export const TaskPageSelectChartDrawer = (props: ITaskPageSelectChartDrawerProps) => {
    const [items, setItems] = useState<ITreeListItem[]>([]);
    const [selectedId, setSelectedId] = useState("");

    useEffect(() => {
        const newItems: ITreeListItem[] = [];
        for (const taskType of props.taskTypes) {
            if (taskType.charts.length === 0) continue;
            newItems.push({
                id: taskType.id,
                title: taskType.code,
                children: taskType.charts.map(i => {
                    return {
                        id: `${taskType.id}#${i.name}`,
                        title: i.title,
                        children: [],
                    };
                })
            });
        }
        setItems(newItems);
    }, [props.taskTypes]);

    const handleOk = () => {
        if (!selectedId) return;
        const values = selectedId.split("#");
        if (values.length !== 2) return;
        const taskTypeId = values[0];
        const chartName = values[1];
        if (!chartName || !taskTypeId) return;
        props.onSelect(taskTypeId, chartName);
    };

    return (
        <PageChartFilterDrawer
            title={Translations.SelectChart}
            buttons={
                <Box display="flex" justifyContent="flex-end">
                    <AppButton variant="outlined" onClick={props.onCancel} sx={{ marginRight: ".5rem" }}>{Translations.Close}</AppButton>
                    <ConfirmationButton onClick={handleOk} disabled={!selectedId}>{Translations.Add}</ConfirmationButton>
                </Box>
            }
            onClose={props.onCancel}
        >
            <TreeList
                items={items}
                selectedId={selectedId}
                onSelect={item => setSelectedId(item.id)}
            />
        </PageChartFilterDrawer>
    );
};
